import PrismicDOM from 'prismic-dom';
import linkResolver from 'prismic/link-resolver';

const sliceHelper = {
  methods: {
    contentFor (obj) {
      return obj[0] && obj[0].text;
    },

    contentAsHtml (content) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(PrismicDOM.RichText.asHtml(content, linkResolver), 'text/html');

      for (const el of doc.body.getElementsByTagName('*')) {
        el.setAttribute(this.$options._scopeId, '');
      }

      return doc.body.innerHTML;
    }
  }
};

export default sliceHelper;
